import { Link } from 'react-router-dom';
import { PageLayout } from '@/pages/PageLayout';

const H2 = ({ children }) => (
  <h2 className="text-xl font-semibold text-slate-900 dark:text-white pt-2">{children}</h2>
);

export function RefundPolicy() {
  return (
    <PageLayout title="Refund Policy">
      <p>
        We want you to be satisfied with AssistlyAI. This policy describes how refunds work for paid
        subscriptions or purchases, where applicable.
      </p>

      <div className="space-y-4">
        <H2>Subscription refunds</H2>
        <p>
          If you are on a paid plan and believe you are eligible for a refund (for example, a billing
          error or a problem we could not resolve within a reasonable time), contact us within{' '}
          <strong>7 days</strong> of the charge you dispute. We will review your request and respond
          as soon as we can.
        </p>
        <p>
          Refunds are issued at our discretion and in line with applicable law. Partial refunds or
          credits may be offered instead of a full refund, depending on usage and the nature of the
          issue.
        </p>
      </div>

      <div className="space-y-4">
        <H2>What may not be refundable</H2>
        <ul className="list-disc pl-5 space-y-2">
          <li>Charges outside the stated refund window, unless required by law.</li>
          <li>Accounts terminated for violation of our Terms of Service.</li>
          <li>Third-party fees (for example app store or payment processor charges) we do not control.</li>
        </ul>
      </div>

      <div className="space-y-4">
        <H2>How to request a refund</H2>
        <p>
          Use the{' '}
          <Link to="/contact" className="text-[#25D366] hover:underline">
            Contact
          </Link>{' '}
          form or message us on WhatsApp with your registered phone number, the date of the charge,
          and a short description of the issue. We may ask for additional information to verify your
          account.
        </p>
      </div>

      <div className="space-y-4">
        <H2>Processing time</H2>
        <p>
          Approved refunds are typically processed within 5–10 business days; timing can vary by bank
          or payment method.
        </p>
      </div>
    </PageLayout>
  );
}
